import React, { useState, useRef, useEffect, useCallback } from "react";
import { Icon, Menu } from "semantic-ui-react";
import {
  Container,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  Table,
  Button,
  LinkRedirect,
} from "./styles";
import { producaov2 as api } from "../../../../../services/apis";
import swal from "sweetalert";
import { isAuthAdmin } from "../../../../../services/auth";

const ListarCertificado = () => {
  const [search, setSearch] = useState("");
  const [certificados, setCertificados] = useState([]);

  useEffect(() => {
    api
      .get("layout-certificados")
      .then(async (res) => {
        let array = {
          local: "ead/certificado",
          texto: `listou os modelos de certificado`,
        };
        await api.post("system_logs", { acao: JSON.stringify(array) });

        const newCertificados = res.data.map(({ id, titulo }) => ({
          id,
          titulo,
        }));
        setCertificados(newCertificados);
      })
      .catch((err) => {
        swal("Erro", "Modelos de certificados não encontrados !", "error");
      });
  }, []);

  return (
    <>
      <Container>
        <Title>Modelos certificados</Title>

        <ContainerInputSearch className="ui fluid left icon input">
          <>
            <Input
              type="search"
              placeholder="Procurar aluno..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />
          </>

          <>
            <CreateButton to="/admin/ead/certificados/criar">
              Criar
            </CreateButton>
          </>
        </ContainerInputSearch>

        <Table size="big" celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Id</Table.HeaderCell>
              <Table.HeaderCell>Título</Table.HeaderCell>
              <Table.HeaderCell>Ações </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {certificados
              .filter((certificado) =>
                certificado.titulo.toLowerCase().includes(search.toLowerCase())
              )
              .map((certificado) => (
                <Table.Row>
                  <Table.Cell>{certificado.id}</Table.Cell>
                  <Table.Cell>{certificado.titulo}</Table.Cell>
                  <Table.Cell>
                    <>
                      <LinkRedirect
                        to={`/admin/ead/certificados/editar/${certificado.id}`}
                      >
                        <Button icon="edit icon" info="edit" />
                      </LinkRedirect>
                    </>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>

          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="4">
                <Menu floated="right" pagination>
                  <Menu.Item as="a" icon>
                    <Icon name="chevron left" />
                  </Menu.Item>
                  <Menu.Item as="a" icon>
                    <Icon name="chevron right" />
                  </Menu.Item>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Container>
    </>
  );
};

export default ListarCertificado;
